var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home cons"},[_vm._m(0),_c('Start',{attrs:{"msg":"Let's meet Jack Rope"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo_wrap"},[_c('a',{attrs:{"href":"https://apps.apple.com/app/jack-rope-runs-season-1/id1524646189?mt=8","target":"_blank"}})])
}]

export { render, staticRenderFns }